import { Campaign } from '../Campaign/Campaign';
import { UserOrganization } from '../User/User';
import { IFormatOrganization } from '../Format/FormatOrganization';

export interface IOrganization {
    id?: number,
    name: string;
    type: OrganizationType;
    parentId?: number;
    description?: string;
    dateCreated?: Date;
    dateLastChanged?: Date;
    dateDeleted?: Date;
    deleted?: boolean;

    activeCampaignCount?: number;
    userRelations?: UserOrganization[];



    children?: Organization[];
    campaigns?: Campaign[];

    specificallyAllowedFormats: IFormatOrganization[];
}

export class Organization implements IOrganization {
    id: number;
    name: string;
    type: OrganizationType;
    parentId: number;
    description: string;
    dateCreated: Date;
    dateLastChanged: Date;
    dateDeleted: Date;
    deleted: boolean;

    activeCampaignCount: number;
    userRelations: UserOrganization[];

    children: Organization[];
    campaigns: Campaign[];

    specificallyAllowedFormats: IFormatOrganization[];

    tempId: number;
    tempParentId: number;

    constructor()
    constructor(obj: IOrganization)
    constructor(obj?: IOrganization) {
        this.name = obj && obj.name || undefined;
        this.type = obj && obj.type || undefined;
        this.children = obj && obj.children || [];
        this.campaigns = obj && obj.campaigns || [];
        this.description = obj && obj.description || undefined;
        this.dateCreated = obj && obj.dateCreated || undefined;
        this.dateLastChanged = obj && obj.dateLastChanged || undefined;
        this.dateDeleted = obj && obj.dateDeleted || undefined;
        this.deleted = obj && obj.deleted != undefined ? obj.deleted : false;
        this.userRelations = obj && obj.userRelations || undefined;
        this.specificallyAllowedFormats = obj && obj.specificallyAllowedFormats || undefined;
    }
}

export enum OrganizationType {
    Organization = 1,
    Advertiser = 2
}
